import "./Events.scss";

import upload from "../../assets/images/icons/upload.svg";

import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { saveAs } from "file-saver";
import axios from 'axios';
import EventsUpcoming from '../../components/EventsUpcoming/EventsUpcoming';
import EventsPast from '../../components/EventsPast/EventsPast';
import TopNav from '../../components/TopNav/TopNav';
import SideBar from '../../components/SideBar/SideBar';

function Events() {
    const [events, setEvents] = useState([]);

    useEffect(() => {
        async function getEvents() {
            try {
                const response = await axios.get("https://zona-app-server-584d567d8841.herokuapp.com/events");
                setEvents(response.data);
            } catch (error) {
                console.log(`events get request didn't work. error: ${error}`);
            }
        }
        getEvents();
    }, []);

    //SUB TABS =============================================================================

    const [upcomingTab, setUpcomingTab] = useState(true);
    const [pastTab, setPastTab] = useState(false);

    function handleSubNavClick(tab) {
        switch (tab) {
            case "upcomingEvents":
                setPastTab(false);
                setUpcomingTab(true);
                break;
            case "pastEvents":
                setUpcomingTab(false);
                setPastTab(true);
                break;
            default:
                break;
        }
    }

    //UPCOMING V PAST ======================================================================

    const formatDate = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");

        return `${year}-${month}-${day}`;
    };

    const formattedDate = formatDate(new Date());

    const [upcomingEvents, setUpcomingEvents] = useState([]);
    const [pastEvents, setPastEvents] = useState([]);

    useEffect(() => {
        const beforeToday = events.filter((event) => event.date.split(" - ")[0] < formattedDate);
        setPastEvents(beforeToday);

        const afterToday = events.filter((event) => event.date.split(" - ")[0] > formattedDate);
        setUpcomingEvents(afterToday);

    }, [formattedDate, events])

    //EXPORTING VENUES DATA ==========================================================

    function handleExportDataClick() {
        try {
            const csvRows = [];

            const headers = Object.keys(events[0]);
            csvRows.push(headers.join(","));

            for (const row of events) {
                const values = headers.map((header) => {
                    const escapedValue = row[header].toString().replace(/"/g, '\\"');
                    return `"${escapedValue}"`;
                });
                csvRows.push(values.join(","));
            }

            const csvContent = csvRows.join("\n");
            const csvBlob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });

            saveAs(csvBlob, "events_data.csv");
        } catch (error) {
            console.error("Error converting JSON to CSV:", error);
        }
    }



    return (
        <main>
            <TopNav />
            <div className="main-container">
                <SideBar />
                <article style={{ width: "100%", display: "flex", justifyContent: "center" }}>
                    <section className="events">
                        <div className="events__top">
                            <h1 className="events__top-heading">Events</h1>
                            <div className="events__top-buttons">
                                <Link to="/events/add" className="events__top-buttons-colorful">
                                    Add new event +
                                </Link>
                                <button onClick={handleExportDataClick} className='events__top-buttons-clear'>
                                    <p className='events__top-buttons-clear-text'>
                                        Export data
                                    </p>
                                    <img className='events__top-buttons-clear-icon' src={upload} alt='upload icon'></img>
                                </button>
                            </div>
                        </div>

                        <div className="events__tabs">
                            <div
                                onClick={() => handleSubNavClick("upcomingEvents")}
                                className={
                                    upcomingTab ? "events__tabs-link events__tabs-link--active" : "events__tabs-link"
                                }
                            >
                                <p className="events__tabs-link-text">Upcoming Events</p>
                            </div>

                            <div
                                onClick={() => handleSubNavClick("pastEvents")}
                                className={
                                    pastTab ? "events__tabs-link events__tabs-link--active" : "events__tabs-link"
                                }
                            >
                                <p className="events__tabs-link-text">Past Events</p>
                            </div>
                        </div>

                        {upcomingTab ? <EventsUpcoming events={upcomingEvents} /> : <EventsPast events={pastEvents} />}
                    </section>
                </article>
            </div>
        </main>
    )
}

export default Events;
